// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__2BCEw","content":"Consent_content__1TU7R","footer":"Consent_footer__kJwQn"};